import React, { useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";
import { dominio } from "../../../routes_backend/routes.jsx";


const AdministrarCertificadosCalidad = () => {
  const [formData, setFormData] = useState({
    nombreFirma: "",
    planta: "",
    usuario: "",
  });

  const [archivo, setArchivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sellos, setSellos] = useState([]);
  const [loadingSellos, setLoadingSellos] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [editando, setEditando] = useState(null);
  const [editForm, setEditForm] = useState({
    nombreFirma: "",
    planta: "",
    usuario: "",
  });
  const [editArchivo, setEditArchivo] = useState(null);
  const [editLoading, setEditLoading] = useState(false);

  const URL_POST = `${dominio}/postCertificadosCalidadSellos`;
  const URL_GET = `${dominio}/getCertificadosCalidadSellos`;
  const URL_PATCH_BASE = `${dominio}/patchCertificadosCalidadSellos`;

  const previewNuevoArchivo = useMemo(() => {
    if (!editArchivo) return null;
    return URL.createObjectURL(editArchivo);
  }, [editArchivo]);

  useEffect(() => {
    return () => {
      if (previewNuevoArchivo) {
        URL.revokeObjectURL(previewNuevoArchivo);
      }
    };
  }, [previewNuevoArchivo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validarPng = (file) => {
    const esPngPorMime = file.type === "image/png";
    const esPngPorExtension = file.name.toLowerCase().endsWith(".png");
    return esPngPorMime && esPngPorExtension;
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      setArchivo(null);
      return;
    }

    if (!validarPng(file)) {
      e.target.value = "";
      setArchivo(null);

      await Swal.fire({
        icon: "warning",
        title: "Archivo no válido",
        text: "Solo se permite un archivo PNG.",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    setArchivo(file);
  };

  const handleEditFileChange = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      setEditArchivo(null);
      return;
    }

    if (!validarPng(file)) {
      e.target.value = "";
      setEditArchivo(null);

      await Swal.fire({
        icon: "warning",
        title: "Archivo no válido",
        text: "Solo se permite un archivo PNG.",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    setEditArchivo(file);
  };

  const obtenerSellos = async () => {
    setLoadingSellos(true);
    try {
      const response = await fetch(URL_GET, {
        method: "GET",
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Error al obtener los sellos");
      }

      setSellos(data.data || []);
    } catch (err) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message || "Error cargando los sellos",
        confirmButtonText: "Aceptar",
      });
    } finally {
      setLoadingSellos(false);
    }
  };

  useEffect(() => {
    obtenerSellos();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!archivo) {
        await Swal.fire({
          icon: "warning",
          title: "Archivo requerido",
          text: "Debes seleccionar un archivo PNG.",
          confirmButtonText: "Aceptar",
        });
        setLoading(false);
        return;
      }

      const body = new FormData();
      body.append("NombreFirma", formData.nombreFirma);
      body.append("Planta", formData.planta);
      body.append("usuario", formData.usuario);
      body.append("sello", archivo);

      const response = await fetch(URL_POST, {
        method: "POST",
        body,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Error al guardar el sello");
      }

      setFormData({
        nombreFirma: "",
        planta: "",
        usuario: "",
      });

      setArchivo(null);

      const fileInput = document.getElementById("sello");
      if (fileInput) fileInput.value = "";

      await obtenerSellos();

      await Swal.fire({
        icon: "success",
        title: "Registro guardado",
        text: `${data.message}${data?.data?.idFirmas ? ` - ID generado: ${data.data.idFirmas}` : ""}`,
        confirmButtonText: "Aceptar",
      });
    } catch (err) {
      await Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: err.message || "Ocurrió un error",
        confirmButtonText: "Aceptar",
      });
    } finally {
      setLoading(false);
    }
  };

  const abrirModalEditar = (item) => {
    setEditando(item);
    setEditForm({
      nombreFirma: item.NombreFirma || "",
      planta: item.Planta || "",
      usuario: item.usuario || "",
    });
    setEditArchivo(null);
    setModalOpen(true);
  };

  const cerrarModalEditar = () => {
    setModalOpen(false);
    setEditando(null);
    setEditArchivo(null);
  };

  const handleEditarSubmit = async (e) => {
    e.preventDefault();
    if (!editando) return;

    setEditLoading(true);

    try {
      const body = new FormData();
      body.append("NombreFirma", editForm.nombreFirma);
      body.append("Planta", editForm.planta);
      body.append("usuario", editForm.usuario);

      if (editArchivo) {
        body.append("sello", editArchivo);
      }

      const response = await fetch(`${URL_PATCH_BASE}/${editando.idFirmas}`, {
        method: "PATCH",
        body,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Error al actualizar el sello");
      }

      await obtenerSellos();
      cerrarModalEditar();

      await Swal.fire({
        icon: "success",
        title: "Registro actualizado",
        text: data.message || "Sello actualizado correctamente",
        confirmButtonText: "Aceptar",
      });
    } catch (err) {
      await Swal.fire({
        icon: "error",
        title: "Error al actualizar",
        text: err.message || "Ocurrió un error al actualizar",
        confirmButtonText: "Aceptar",
      });
    } finally {
      setEditLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.content}>
        <div style={styles.formCard}>
          <div style={styles.header}>
            <h2 style={styles.title}>Registro de Sellos</h2>
            <p style={styles.subtitle}>
              Agrega un sello de certificado de calidad en formato PNG.
            </p>
          </div>

          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div style={styles.field}>
              <label style={styles.label}>Nombre de Firma</label>
              <input
                type="text"
                name="nombreFirma"
                value={formData.nombreFirma}
                onChange={handleChange}
                required
                style={styles.input}
                placeholder="Ej. Firma Planta Norte"
              />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Planta</label>
              <input
                type="text"
                name="planta"
                value={formData.planta}
                onChange={handleChange}
                required
                style={styles.input}
                placeholder="Ej. Planta Central"
              />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Usuario</label>
              <input
                type="number"
                name="usuario"
                value={formData.usuario}
                onChange={handleChange}
                required
                style={styles.input}
                placeholder="Ej. 1"
              />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Sello (solo PNG)</label>
              <input
                id="sello"
                type="file"
                accept=".png,image/png"
                onChange={handleFileChange}
                required
                style={styles.fileInput}
              />
              <small style={styles.helperText}>
                Solo se permiten archivos .png
              </small>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={loading ? styles.buttonDisabled : styles.button}
            >
              {loading ? "Guardando..." : "Guardar Sello"}
            </button>
          </form>
        </div>

        <div style={styles.listSection}>
          <div style={styles.listHeader}>
            <h3 style={styles.listTitle}>Sellos registrados</h3>
            <span style={styles.counter}>{sellos.length}</span>
          </div>

          {loadingSellos ? (
            <div style={styles.emptyState}>Cargando sellos...</div>
          ) : sellos.length === 0 ? (
            <div style={styles.emptyState}>No hay sellos registrados.</div>
          ) : (
            <div style={styles.cardsGrid}>
              {sellos.map((item) => (
                <div key={item.idFirmas} style={styles.card}>
                  <div style={styles.previewWrapper}>
                    {item.SelloBase64 ? (
                      <img
                        src={`data:image/png;base64,${item.SelloBase64}`}
                        alt={item.NombreFirma || "Sello"}
                        style={styles.previewImage}
                      />
                    ) : (
                      <div style={styles.previewEmpty}>Sin imagen</div>
                    )}
                  </div>

                  <div style={styles.cardBody}>
                    <div style={styles.cardTopRow}>
                      <h4 style={styles.cardTitle}>{item.NombreFirma || "Sin nombre"}</h4>
                      <span style={styles.badge}>ID {item.idFirmas}</span>
                    </div>

                    <div style={styles.cardInfo}>
                      <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Planta:</span>
                        <span style={styles.infoValue}>{item.Planta || "-"}</span>
                      </div>

                      <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Usuario:</span>
                        <span style={styles.infoValue}>{item.usuario || "-"}</span>
                      </div>

                      <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Creación:</span>
                        <span style={styles.infoValue}>{item.fechaCreacion || "-"}</span>
                      </div>

                      <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Actualización:</span>
                        <span style={styles.infoValue}>{item.fechaActualizacion || "-"}</span>
                      </div>
                    </div>

                    <div style={styles.cardActions}>
                      <button
                        type="button"
                        style={styles.editButton}
                        onClick={() => abrirModalEditar(item)}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {modalOpen && editando && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <div style={styles.modalHeader}>
              <div>
                <h3 style={styles.modalTitle}>Editar sello</h3>
                <p style={styles.modalSubtitle}>ID {editando.idFirmas}</p>
              </div>
              <button type="button" style={styles.closeButton} onClick={cerrarModalEditar}>
                ×
              </button>
            </div>

            <form onSubmit={handleEditarSubmit} encType="multipart/form-data">
              <div style={styles.modalGrid}>
                <div style={styles.modalLeft}>
                  <div style={styles.field}>
                    <label style={styles.label}>Nombre de Firma</label>
                    <input
                      type="text"
                      name="nombreFirma"
                      value={editForm.nombreFirma}
                      onChange={handleEditChange}
                      required
                      style={styles.input}
                    />
                  </div>

                  <div style={styles.field}>
                    <label style={styles.label}>Planta</label>
                    <input
                      type="text"
                      name="planta"
                      value={editForm.planta}
                      onChange={handleEditChange}
                      required
                      style={styles.input}
                    />
                  </div>

                  <div style={styles.field}>
                    <label style={styles.label}>Usuario</label>
                    <input
                      type="number"
                      name="usuario"
                      value={editForm.usuario}
                      onChange={handleEditChange}
                      required
                      style={styles.input}
                    />
                  </div>

                  <div style={styles.field}>
                    <label style={styles.label}>Nuevo sello (PNG opcional)</label>
                    <input
                      type="file"
                      accept=".png,image/png"
                      onChange={handleEditFileChange}
                      style={styles.fileInput}
                    />
                    <small style={styles.helperText}>
                      Déjalo vacío si no quieres cambiar la imagen.
                    </small>
                  </div>
                </div>

                <div style={styles.modalRight}>
                  <div style={styles.previewBox}>
                    <span style={styles.previewTitle}>Vista previa actual</span>
                    {editando.SelloBase64 ? (
                      <img
                        src={`data:image/png;base64,${editando.SelloBase64}`}
                        alt="Sello actual"
                        style={styles.modalPreviewImage}
                      />
                    ) : (
                      <div style={styles.previewEmpty}>Sin imagen</div>
                    )}
                  </div>

                  {previewNuevoArchivo && (
                    <div style={styles.previewBox}>
                      <span style={styles.previewTitle}>Nuevo PNG</span>
                      <img
                        src={previewNuevoArchivo}
                        alt="Nuevo sello"
                        style={styles.modalPreviewImage}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div style={styles.modalActions}>
                <button type="button" style={styles.cancelButton} onClick={cerrarModalEditar}>
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={editLoading}
                  style={editLoading ? styles.buttonDisabledSmall : styles.buttonSmall}
                >
                  {editLoading ? "Actualizando..." : "Guardar cambios"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  page: {
    padding: "24px",
    backgroundColor: "#f4f7fb",
    minHeight: "100vh",
  },
  content: {
    display: "grid",
    gridTemplateColumns: "420px 1fr",
    gap: "24px",
    alignItems: "start",
  },
  formCard: {
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "14px",
    padding: "22px",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.08)",
    border: "1px solid #e5e7eb",
  },
  header: {
    marginBottom: "18px",
  },
  title: {
    margin: 0,
    fontSize: "22px",
    fontWeight: "700",
    color: "#1f2937",
  },
  subtitle: {
    margin: "6px 0 0 0",
    fontSize: "13px",
    color: "#6b7280",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "14px",
  },
  label: {
    marginBottom: "6px",
    fontSize: "13px",
    fontWeight: "600",
    color: "#374151",
  },
  input: {
    height: "40px",
    borderRadius: "10px",
    border: "1px solid #d1d5db",
    padding: "0 12px",
    fontSize: "14px",
    outline: "none",
    backgroundColor: "#fff",
  },
  fileInput: {
    borderRadius: "10px",
    border: "1px solid #d1d5db",
    padding: "10px 12px",
    fontSize: "14px",
    backgroundColor: "#fff",
  },
  helperText: {
    marginTop: "6px",
    color: "#6b7280",
    fontSize: "12px",
  },
  button: {
    width: "100%",
    height: "42px",
    border: "none",
    borderRadius: "10px",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "6px",
  },
  buttonDisabled: {
    width: "100%",
    height: "42px",
    border: "none",
    borderRadius: "10px",
    backgroundColor: "#93c5fd",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "not-allowed",
    marginTop: "6px",
  },
  buttonSmall: {
    minWidth: "150px",
    height: "40px",
    border: "none",
    borderRadius: "10px",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    padding: "0 16px",
  },
  buttonDisabledSmall: {
    minWidth: "150px",
    height: "40px",
    border: "none",
    borderRadius: "10px",
    backgroundColor: "#93c5fd",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "not-allowed",
    padding: "0 16px",
  },
  listSection: {
    backgroundColor: "#ffffff",
    borderRadius: "14px",
    padding: "20px",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.08)",
    border: "1px solid #e5e7eb",
    minHeight: "300px",
  },
  listHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "18px",
  },
  listTitle: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "700",
    color: "#1f2937",
  },
  counter: {
    minWidth: "32px",
    height: "32px",
    borderRadius: "999px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#eff6ff",
    color: "#1d4ed8",
    fontWeight: "700",
    fontSize: "13px",
    padding: "0 10px",
  },
  cardsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
    gap: "16px",
  },
  card: {
    display: "flex",
    gap: "14px",
    border: "1px solid #e5e7eb",
    borderRadius: "14px",
    padding: "14px",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 10px rgba(15, 23, 42, 0.04)",
    alignItems: "center",
  },
  previewWrapper: {
    width: "100px",
    height: "100px",
    minWidth: "100px",
    borderRadius: "12px",
    overflow: "hidden",
    border: "1px solid #d1d5db",
    backgroundColor: "#f9fafb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  previewImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    backgroundColor: "#fff",
  },
  previewEmpty: {
    fontSize: "12px",
    color: "#9ca3af",
    textAlign: "center",
    padding: "8px",
  },
  cardBody: {
    flex: 1,
    minWidth: 0,
  },
  cardTopRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    alignItems: "flex-start",
    marginBottom: "10px",
  },
  cardTitle: {
    margin: 0,
    fontSize: "16px",
    fontWeight: "700",
    color: "#111827",
  },
  badge: {
    fontSize: "11px",
    fontWeight: "700",
    color: "#1d4ed8",
    backgroundColor: "#dbeafe",
    borderRadius: "999px",
    padding: "4px 8px",
    whiteSpace: "nowrap",
  },
  cardInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  infoRow: {
    display: "flex",
    gap: "6px",
    fontSize: "13px",
    flexWrap: "wrap",
  },
  infoLabel: {
    fontWeight: "700",
    color: "#374151",
  },
  infoValue: {
    color: "#6b7280",
  },
  cardActions: {
    marginTop: "14px",
    display: "flex",
    justifyContent: "flex-end",
  },
  editButton: {
    border: "none",
    borderRadius: "8px",
    backgroundColor: "#f59e0b",
    color: "#ffffff",
    fontSize: "13px",
    fontWeight: "600",
    padding: "8px 12px",
    cursor: "pointer",
  },
  emptyState: {
    padding: "30px",
    textAlign: "center",
    color: "#6b7280",
    border: "1px dashed #d1d5db",
    borderRadius: "12px",
    backgroundColor: "#f9fafb",
  },
  modalOverlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(15, 23, 42, 0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "20px",
  },
  modal: {
    width: "100%",
    maxWidth: "860px",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    padding: "22px",
    boxShadow: "0 20px 50px rgba(0,0,0,0.18)",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "18px",
  },
  modalTitle: {
    margin: 0,
    fontSize: "22px",
    fontWeight: "700",
    color: "#111827",
  },
  modalSubtitle: {
    margin: "4px 0 0 0",
    color: "#6b7280",
    fontSize: "13px",
  },
  closeButton: {
    width: "36px",
    height: "36px",
    borderRadius: "999px",
    border: "none",
    backgroundColor: "#f3f4f6",
    cursor: "pointer",
    fontSize: "22px",
    lineHeight: 1,
  },
  modalGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 280px",
    gap: "20px",
    alignItems: "start",
  },
  modalLeft: {
    minWidth: 0,
  },
  modalRight: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  previewBox: {
    border: "1px solid #e5e7eb",
    borderRadius: "14px",
    padding: "14px",
    backgroundColor: "#f9fafb",
  },
  previewTitle: {
    display: "block",
    marginBottom: "10px",
    fontSize: "13px",
    fontWeight: "700",
    color: "#374151",
  },
  modalPreviewImage: {
    width: "100%",
    maxHeight: "220px",
    objectFit: "contain",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    border: "1px solid #d1d5db",
  },
  modalActions: {
    marginTop: "18px",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  cancelButton: {
    minWidth: "120px",
    height: "40px",
    border: "1px solid #d1d5db",
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    color: "#374151",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    padding: "0 16px",
  },
};

export default AdministrarCertificadosCalidad;